var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    attrs: {
      dense: "",
      headers: _vm.headers,
      items: _vm.filterItems,
      "fixed-header": _vm.fixedHeader,
      height: _vm.tableHeight,
      "custom-sort": _vm.sortFunction,
    },
    scopedSlots: _vm._u(
      [
        _vm.showFilter
          ? {
              key: "top",
              fn: function () {
                return [
                  _c(
                    "v-layout",
                    { staticClass: "fullWidth px-3" },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c("v-select", {
                            staticClass: "mr-1",
                            attrs: {
                              dense: "",
                              label: _vm.$vuetify.lang.t(
                                "webmap.featureTable.labels.column"
                              ),
                              items: _vm.availableColumns,
                              "return-object": "",
                              disabled: _vm.filterDisabled,
                            },
                            on: { change: _vm.selectedColumnChanged },
                            model: {
                              value: _vm.selectedColumn,
                              callback: function ($$v) {
                                _vm.selectedColumn = $$v
                              },
                              expression: "selectedColumn",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "mr-1",
                            attrs: {
                              dense: "",
                              label: _vm.$vuetify.lang.t(
                                "webmap.featureTable.labels.filter"
                              ),
                              items: _vm.filterTypes,
                              disabled: _vm.filterDisabled,
                            },
                            model: {
                              value: _vm.filterType,
                              callback: function ($$v) {
                                _vm.filterType = $$v
                              },
                              expression: "filterType",
                            },
                          }),
                          _vm._v(" "),
                          _c(_vm.valueComponent, {
                            ref: "userInput",
                            tag: "component",
                            staticClass: "mr-1",
                            attrs: {
                              dense: "",
                              label: _vm.$vuetify.lang.t(
                                "webmap.featureTable.labels.value"
                              ),
                              rules: _vm.filterRules,
                              disabled: _vm.filterDisabled,
                              "hide-spin-buttons": "",
                              type: _vm.valueType,
                              items: _vm.listItems,
                            },
                            model: {
                              value: _vm.filterValue,
                              callback: function ($$v) {
                                _vm.filterValue = $$v
                              },
                              expression: "filterValue",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mr-1",
                                            attrs: {
                                              icon: "",
                                              small: "",
                                              disabled: _vm.applyFilterDisabled,
                                              "aria-label": _vm.$vuetify.lang.t(
                                                "webmap.ariaLabels.filter"
                                              ),
                                            },
                                            on: {
                                              click: _vm.applyFilterHandler,
                                            },
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-filter-outline"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "webmap.tooltips.filter"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              small: "",
                                              disabled:
                                                _vm.removeFilterDisabled,
                                              "aria-label": _vm.$vuetify.lang.t(
                                                "webmap.ariaLabels.removeFilter"
                                              ),
                                            },
                                            on: {
                                              click: _vm.clearFilterHandler,
                                            },
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-filter-off-outline"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "webmap.tooltips.removeFilter"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        _vm._l(_vm.headers, function (header) {
          return {
            key: "header." + header.value,
            fn: function (ref) {
              var header = ref.header
              return [
                header.value !== "__actions"
                  ? _c(
                      "div",
                      {
                        key: header.value,
                        staticClass: "d-inline-block",
                        style: _vm.headerWidth(header),
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c("span", [_vm._v(_vm._s(header.text))]),
                            _vm._v(" "),
                            header.closable ? _c("v-spacer") : _vm._e(),
                            _vm._v(" "),
                            header.closable
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { left: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      "x-small": "",
                                                      "aria-label":
                                                        _vm.closeLabel,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.removeColumn(
                                                          header
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("mdi-close"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.closeToolTip)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          }
        }),
        {
          key: "item",
          fn: function (ref) {
            var item = ref.item
            var index = ref.index
            return [
              _c(
                "tr",
                _vm._l(_vm.headers, function (col, columnIndex) {
                  return _c("td", [
                    col.value !== "__actions"
                      ? _c("span", [
                          _vm.isUrl(item, col)
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.getCellData(item, col),
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.getCellData(item, col)))]
                              )
                            : _c("span", [
                                _vm._v(_vm._s(_vm.getCellData(item, col))),
                              ]),
                        ])
                      : _c(
                          "span",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { left: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  small: "",
                                                  "aria-label": _vm.viewLabel,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.viewClickedHandler(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v("mdi-eye")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(_vm.viewToolTip))]),
                              ]
                            ),
                          ],
                          1
                        ),
                  ])
                }),
                0
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }